/*
 * 🚨 CRITICAL FIX: Replaced MockSupabase with Real Supabase Client
 * 
 * PREVIOUS ISSUE: This file contained a MockSupabase class that was preventing
 * real database queries and authentication from working. Route points were not
 * loading because:
 * - No real authentication (auth.uid() returned null)
 * - No real database queries
 * - RLS policies were blocking access due to missing auth
 * 
 * SOLUTION: Replaced with real Supabase client that properly handles:
 * - Authentication with auth.uid()
 * - Real database queries
 * - RLS policy enforcement
 * 
 * REQUIRED ENVIRONMENT VARIABLES:
 * - REACT_APP_SUPABASE_URL: Your Supabase project URL
 * - REACT_APP_SUPABASE_ANON_KEY: Your Supabase anonymous key
 * 
 * If you see "Missing Supabase environment variables" error:
 * 1. Create .env.local file in project root
 * 2. Add the required environment variables
 * 3. Restart the development server
 */

import { createClient } from '@supabase/supabase-js';

// Get Supabase URL and anon key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env.local file.');
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl ? 'Set' : 'Missing');
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'Set' : 'Missing');
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.');
}

// Create the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Debug function to check authentication status
export const checkAuthStatus = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    console.log('[DEBUG] Auth status check:', { user: user?.id, error });
    return { user, error };
          } catch (error) {
    console.error('[ERROR] Auth check failed:', error);
    return { user: null, error };
      }
    };

export default supabase; 